import moment from 'moment'

const poBoxPattern = /^ *((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i

const nameValidation = [
  v => /^[a-zA-Z]/.test(v[0]) || 'First character must be a letter',
  v => /^.[a-zA-Z'\s-.]*$/.test(v) || "Only allow alpha (a-z, A-Z), single quote ('), hyphen (-), and period (.) characters",
]

export const phoneNumberData = ( greenSkyLegalContent ) => {
  return {
    label: 'Cell Phone Number',
    v_model_name: 'phoneNumber',
    rules: [
      (v) => !!v || 'Phone Number is required',
      (v) => /^\d{10}$/.test(v) || 'Phone Number must be valid'
    ],
    required: true,
    mask: 'phone',
    id: 'test-phone',
    disclaimerId: 'phone-tooltip',
    hasDisclaimer: true,
    disclaimerText: 'By providing your mobile phone number, you authorize ' +
    'any financial institution that makes a loan to you and its successors, ' +
    'assigns or service providers to contact you at this mobile number by ' +
    'phone or text message using automated telephone dialing system or ' +
    'artificial or prerecorded voice messages, for any purposes related to ' +
    'servicing the loan.',
    greenskyPreQualDisclaimerText: 'If you do not have a mobile number then enter an alternative number. If you provide a mobile phone number, you authorize any financial institution that makes a GreenSky® loan to you and its agents, contractors, successors, assigns, or service providers to contact you at this mobile number, and any future number that you provide for your cellular telephone or other wireless device, by phone or text message using automated telephone dialing system or artificial or prerecorded voice messages, for any legal purpose, including, but not limited to, servicing a loan. You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359.',
    greenskyPreQualMobileNumberDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.phoneDisclosure : 'You understand that if you have provided your mobile telephone number in any application field you authorize any financial institution that makes a GreenSky® loan to you and its agents, contractors, successors, assigns, or service providers to contact you at this mobile number and any future number that you provide for your cellular telephone or other wireless device by phone or text message using automated telephone dialing system or artificial or prerecorded voice messages, for any legal purpose, including, but not limited to, servicing a loan.  You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359.',
    greenskyDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.phoneDisclosure : 'You understand that if you have provided your mobile telephone number in any application field you authorize any financial institution that makes a GreenSky® loan to you and its agents, contractors, successors, assigns, or service providers to contact you at this mobile number and any future number that you provide for your cellular telephone or other wireless device by phone or text message using automated telephone dialing system or artificial or prerecorded voice messages, for any legal purpose, including, but not limited to, servicing a loan.  You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359.',
    disclaimerVariable: 'showPhone'
  }
}

export const formDataPageOne = ( greenSkyLegalContent ) => {
  return [
    {
      id: 'form-data-page-one-first-name',
      label: 'First Name',
      v_model_name: 'firstName',
      rules: [
        (v) => !!v || 'First Name is required'
      ].concat(nameValidation),
      required: true
    },
    {
      id: 'form-data-page-one-last-name',
      label: 'Last Name',
      v_model_name: 'lastName',
      rules: [
        (v) => !!v || 'Last Name is required'
      ].concat(nameValidation),
      required: true
    },
    {
      id: 'form-data-page-one-street-line-1',
      label: 'Street Address (P.O. Box not permitted)',
      disclaimerId: 'address-tooltip',
      hasDisclaimer: true,
      v_model_name: 'streetAddress',
      rules: [
        (v) => !!v || 'Street Address is required',
        (v) => !(poBoxPattern.test(v)) || 'PO Box not permitted'
      ],
      required: true,
      greenskyDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.streetAddressDisclosure : "Physical address required. No P.O. Boxes. If you are a participant in a state-sponsored Address Confidentiality Program, please call us at 1-833-215-6869 to apply.",
      greenskyPreQualDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.streetAddressDisclosure : "Physical address required. No P.O. Boxes. If you are a participant in a state-sponsored Address Confidentiality Program, please call us at 1-833-215-6869 to apply.",
    },
    {
      id: 'form-data-page-one-street-line-2',
      label: 'Suite or Apt Number',
      v_model_name: 'aptNumber',
      rules: [
        (v) => !(poBoxPattern.test(v)) || 'PO Box not permitted'
      ],
      required: false
    },
    {
      id: 'form-data-page-one-city',
      label: 'City',
      v_model_name: 'city',
      rules: [ (v) => !!v || 'City is required' ],
      required: true
    },
    {
      id: 'form-data-page-one-state',
      label: 'State',
      v_model_name: 'state',
      rules: [
        (v) => !!v || 'State is required',
        (v) => /^[A-Z]{2}$/.test(v) || 'State must be 2 capitalized letters'
      ],
      required: true
    },
    {
      id: 'form-data-page-one-zip',
      label: 'Zip',
      v_model_name: 'zipCode',
      rules: [
        (v) => !!v || 'Zip is required',
        (v) => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Zip must be of form ##### or #####-####'],
      required: true
    },
  ].map(field => {
    if (typeof field.rules !== 'function') {
      const rules = [ ...field.rules ]
      field.rules = d => rules
    }

    return field
    })
}

export const wisconsinSpouseData = [
  {
    label: 'Spouse First Name',
    v_model_name: 'spouseFirstName',
    rules: [ (v) => !!v || 'Spouse First Name is required' ],
    required: true,
    id: 'test-spouse-first-name'
  },
  {
    label: 'Spouse Last Name',
    v_model_name: 'spouseLastName',
    rules: [ (v) => !!v || 'Spouse Last Name is required' ],
    required: true,
    id: 'test-spouse-last-name'
  },
  {
    label: 'Spouse Street Address',
    v_model_name: 'spouseStreetAddress',
    rules: [
      (v) => !!v || 'Spouse Street Address is required',
      (v) => !(poBoxPattern.test(v)) || 'PO Box not permitted'
    ],

    required: true
  },
  {
    label: 'Spouse Suite or Apt Number',
    v_model_name: 'spouseAptNumber',
    rules: [
      (v) => !(poBoxPattern.test(v)) || 'PO Box not permitted'
    ],
    required: false
  },
  {
    label: 'Spouse City',
    v_model_name: 'spouseCity',
    rules: [
      (v) => !!v || 'Spouse City is required'
    ],
    required: true
  },
  {
    label: 'Spouse State',
    v_model_name: 'spouseState',
    rules: [
      (v) => !!v || 'Spouse State is required',
      (v) => /^[A-Za-z]{2}$/.test(v) || 'State must be 2 letters'
    ],
    required: true
  },
  {
    label: 'Spouse Zip',
    v_model_name: 'spouseZipCode',
    rules: [
      (v) => !!v || 'Spouse Zip is required',
      (v) => /^\d{5}(?:[-\s]\d{4})?$/.test(v) || 'Zip must be of form ##### or #####-####'],
    required: true
  }
]

export const dateOfBirthData = (greenSkyLegalContent) => {

  return {
    label: 'Date of Birth',
    disclaimerId: 'dob-tooltip',
    hasDisclaimer: true,
    v_model_name: 'dateOfBirth',
    rules: [
      (v) => !!v || 'Date of Birth is required',
      (v) => /^\d{8}$/.test(v) || 'Date of Birth must be in MM/DD/YYYY format',
      (v) => /^(?:0[1-9]|1[012])(?:0[1-9]|[12]\d|3[01])((?:19|20)\d\d$)/.test(v) || 'Please enter a Valid Date of Birth',
      // ctx => ([
      //   (v) => {
      //     const yearsOld = moment().diff(moment(v, 'MMDDYYYY'), 'years')
      //     const { state } = ctx.customerDataCopy
  
      //     const oldEnough = state === 'AL'
      //       ? yearsOld >= 19
      //       : yearsOld >= 18
  
      //     return oldEnough || 'Applicants must be 18+ years old (19+ in AL)'
      //     }
      //   ]),
    ],
    greenskyDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.dateOfBirthDisclosure : 'MM/DD/YYYY. Only U.S. Residents 18 years and older (19 in Alabama) may apply.',
    greenskyPreQualDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.dateOfBirthDisclosure : 'MM/DD/YYYY. Only U.S. Residents 18 years and older (19 in Alabama) may apply.',
    required: true,
    mask: '##/##/####',
    placeholder: 'MM/DD/YYYY',
  }
}

export const emailFormData = (greenSkyLegalContent) => {

  return {
    label: 'Email Address',
    v_model_name: 'emailAddress',
    rules: [
      (v) => !!v || 'Email Address is required',
      (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
    ],
    required: true,
    id: 'form-data-page-one-email',
    disclaimerId: 'email-tooltip',
    hasDisclaimer: true,
    disclaimerText: 'The email must belong to the Applicant/Co-Applicant. ' +
    'You must ensure that the provided email is real and can receive the ' +
    'important application information. Your merchant/provider will use it ' +
    'to send you the confidential legal documents.',
    greenskyDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.emailDisclosureRequired : 'By providing your email address, you agree that we may use this email address to send your notifications and messages related to your account, respond to email requests we receive from you, and to contact you about our products, services, special offers, and other promotions.  You understand that email is not a secure means of communication and we are not responsible for any misdirection, interception, or other disclosure of the contents of an email properly addressed to you. If you would like to opt out, contact us at 866-936-0602.',
    greenskyPreQualDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.emailDisclosureRequired : 'By providing your email address, you agree that we may use this email address to send your notifications and messages related to your account, respond to email requests we receive from you, and to contact you about our products, services, special offers, and other promotions.  You understand that email is not a secure means of communication and we are not responsible for any misdirection, interception, or other disclosure of the contents of an email properly addressed to you. If you would like to opt out, contact us at 866-936-0602.',
    fortivaDisclaimerText: 'Important information will be sent to the email ' +
    'address provided.  Are you sure this is your correct email address?  If ' +
    'not, please update your email address at this time.',
    disclaimerVariable: 'showEmail'
  }
}

export const grossAnnualIncomeData = (greenSkyLegalContent) => {

  return {
    label: 'Gross Annual Income',
    fortivaLabel: 'Gross Annual Income †',
    v_model_name: 'grossAnnualIncome',
    rules: [
      (v) => !!v || 'Gross Annual Income is required',
      (v) => parseInt(v.slice(1).replace(',', '')) >= 1000 || 'Gross Annual Income must be greater than $1000',

    ],
    required: true,
    id: 'test-income',
    disclaimerId: 'income-tooltip',
    hasDisclaimer: true,
    disclaimerText: '<strong>Examples:</strong> Annual salary (before taxes), ' +
    'alimony, child support, investment income, social security, etc.<br> ' +
    '<strong>NOTE:</strong> Alimony, child support, or separate maintenance ' +
    'payments need not be revealed if you do not wish to have them considered ' +
    'as a basis for repaying the loan.<br> <strong>Married Wisconsin Residents:' +
    '</strong> Combine spouse and your income information once.',
    greenskyDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.grossIncomeDisclosure : '<strong>Examples</strong>: Annual salary (before taxes), alimony, child support, investment income, social security, etc. <strong>NOTE:</strong> Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. <strong>MARRIED WI Residents only:</strong> If you are applying for an individual account and your spouse also is a Wisconsin resident, combine your and your spouse&rsquo;s financial information.',
    greenskyPreQualDisclaimerText: greenSkyLegalContent ? greenSkyLegalContent.grossIncomeDisclosure : '<strong>Examples</strong>: Annual salary (before taxes), alimony, child support, investment income, social security, etc. <strong>NOTE:</strong> Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. <strong>MARRIED WI Residents only:</strong> If you are applying for an individual account and your spouse also is a Wisconsin resident, combine your and your spouse&rsquo;s financial information.',
    fortivaDisclaimerText: '† Alimony, child support or separate maintenance income need ' +
    'not be included if you do not wish to have it considered as a basis for ' +
    'repaying this obligation.<br/><br/><strong>Married Wisconsin Residents</strong>: ' +
    'Combine your and your spouse’s information on this application.',
    disclaimerVariable: 'showIncome',
    money: {
      prefix: '$',
      precision: 0,
      thousands: ',',
      decimal: '.'
    }
  }
}

export const formDataPageTwo = (greenSkyLegalContent) => {

  return [
    {
      label: 'Social Security Number',
      v_model_name: 'ssNumber',
      rules: [
        (v) => !!v || 'Social Security Number is required',
        (v) => /^\d{9}$/.test(v) || 'Social Security Number must be valid'
      ],
      required: true,
      mask: 'social',
      id: 'test-ss',
      icon: 'lock',
      hint: 'We use 256-bit SSL protection and strict, high levels of ' +
      'security & encryption standards to keep your information safe'
    },
    grossAnnualIncomeData(greenSkyLegalContent),
    phoneNumberData(greenSkyLegalContent),
    //TODO document attrs to v-bind idea
    /*{
      type: 'consent-checkbox',
      v_model_name: 'applicantMobileOptIn',
      id: 'applicantMobileOptIn',
      attrs: {
        text: `By checking this box, you understand that if you have provided your mobile telephone number in any application field you authorize any financial institution that makes a GreenSky® loan to you and its agents, contractors, successors, assigns, or service providers to contact you at this mobile number and any future number that you provide for your cellular telephone or other wireless device by phone or text message using automated telephone dialing system or artificial or prerecorded voice messages, for any legal purpose, including, but not limited to, servicing a loan. You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359.`,
      },
    },*/
    /*{
      type: 'v-checkbox',
      v_model_name: 'applicantMobileOptIn',
      id: 'applicantMobileOptIn',
      //label: `By checking this box, you understand that if you have provided your mobile telephone number in any application field you authorize any financial institution that makes a GreenSky® loan to you and its agents, contractors, successors, assigns, or service providers to contact you at this mobile number and any future number that you provide for your cellular telephone or other wireless device by phone or text message using automated telephone dialing system or artificial or prerecorded voice messages, for any legal purpose, including, but not limited to, servicing a loan. You may revoke your consent at any time by contacting us at 1-866-936-0602 or P.O. Box 29429, Atlanta, GA 30359.`,
    },*/
  ]
}

export const greenskyFooter = (greenSkyLegalContent) => {
  return greenSkyLegalContent ? greenSkyLegalContent.mainFooter : "<div class=\"mb-3\" id=\"footer-text\" tabindex=\"0\"><span id=\"copyrights_message\">&copy; 2006 - 2022 GreenSky, LLC. All Rights Reserved.</span> | GreenSky<sup class=\"sup\">&reg;</sup> and GreenSky Patient Solutions<sup class=\"sup\">&reg;</sup> are loan program names for certain consumer credit plans extended by participating lenders to borrowers for the purchase of goods and/or services from participating merchants/providers. Participating lenders are federally insured, federal and state chartered financial institutions providing credit without regard to age, race, color, religion, national origin, gender or familial status. GreenSky<sup class=\"sup\">&reg;</sup> and GreenSky Patient Solutions<sup class=\"sup\">&reg;</sup> are registered trademarks of GreenSky, LLC. GreenSky Servicing, LLC services the loans on behalf of participating lenders. NMLS #1416362. GreenSky, LLC and GreenSky Servicing, LLC are subsidiaries of Goldman Sachs Bank USA. Loans originated by Goldman Sachs are issued by Goldman Sachs Bank USA, Salt Lake City Branch.</div><img src=\"https://cms.uat.greensky.com/images/home-lender.svg\" id=\"eol-logo\" tabindex=\"0\" alt=\"Equal Opportunity Lender\" style=\"margin-top: 1rem;margin-bottom: 1rem;display: block;\">"
}
export const ageDisclaimer = 'Only U.S. residents 18 years or older ' +
        '(19 years or older in Alabama and Nebraska) may apply.'

